(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function observe(targets, prepare) {
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    prepare();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    targets.forEach((target) => observer.observe(target));
  }

  function revealShop(root = document) {
    if (reducedMotion.matches) return;
    const selector = '.studio-shop';
    const sections = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];

    sections.forEach((section) => {
      if (section.dataset.revealReady === 'true') return;
      const content = [...section.querySelectorAll('.collection-card__content')];
      if (!content.length) return;
      content.forEach((item) => item.classList.remove('is-visible'));
      section.classList.add('studio-shop--reveal-ready');
      section.dataset.revealReady = 'true';
      observe(content, () => {});
    });
  }

  function revealHomepage() {
    if (reducedMotion.matches || !document.body.classList.contains('template-index')) return;
    const targets = [...document.querySelectorAll([
      '.template-index .slide__content',
      '.template-index .hero__content-wrapper',
      '.template-index .section-resource-list__content',
      '.template-index .collection-card__content',
      '.template-index .product-card__content',
      '.template-index .studio-process__intro',
      '.template-index .studio-process__caption',
      '.template-index .studio-process__actions'
    ].join(','))];
    if (!targets.length) return;

    document.body.classList.add('template-index--reveal-ready');
    targets.forEach((target) => {
      target.classList.add('home-scroll-reveal');
      target.classList.remove('is-visible');
    });
    observe(targets, () => {});
  }

  function initialize(root = document) {
    revealShop(root);
    if (root === document) revealHomepage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
